import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { LOAN_CATEGORIES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export default function LoanCategories() {
  return (
    <section
      id="loans"
      data-testid="loan-categories"
      className="py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
            Loan Solutions
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-bold font-heading tracking-tight text-[#0F2D52]">
            A curated range of secured and unsecured products
          </h2>
          <p className="mt-3 text-base text-gray-600 leading-relaxed">
            We help you evaluate loan solutions across categories and match your
            requirement to a suitable lender&rsquo;s policy.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {LOAN_CATEGORIES.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Coins;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                whileHover={{ y: -4 }}
                data-testid={`loan-card-${i}`}
                className="group relative rounded-2xl bg-white border border-gray-200 p-6 shadow-[0_2px_8px_rgba(0,0,0,0.02)] hover:shadow-[0_16px_36px_rgba(15,45,82,0.08)] mm-transition"
              >
                <div className="w-11 h-11 rounded-xl bg-[#0F2D52]/5 flex items-center justify-center mb-4 group-hover:bg-[#0F2D52]/10 mm-transition">
                  <Icon className="h-5 w-5 text-[#1E5AA8]" strokeWidth={1.6} />
                </div>
                <h3 className="text-lg font-bold text-[#0F2D52] font-heading tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                  {c.desc}
                </p>
                <div className="mt-4 flex items-center">
                  <span
                    className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] ${
                      c.type === "Secured"
                        ? "bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200"
                        : "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200"
                    }`}
                  >
                    {c.type}
                  </span>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <div className="text-[10px] uppercase tracking-[0.14em] font-bold text-gray-500 mb-1">
                    Suitable for
                  </div>
                  <div className="text-xs text-gray-700">{c.suitable}</div>
                </div>
                <a
                  href={c.url}
                  data-testid={`loan-card-learn-${i}`}
                  className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#0F2D52] hover:text-[#1E5AA8] mm-transition"
                >
                  Learn more
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
